var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7638 21.1824C22.1011 19.247 22.1011 16.1073 19.763 14.1708C17.4262 16.1073 17.4262 19.2458 19.7638 21.1824Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.763 14.1708C19.6015 14.3047 19.4522 14.4449 19.313 14.5891C21.0497 16.3915 21.0497 18.9626 19.3138 20.7641C19.4532 20.9088 19.6022 21.0489 19.7638 21.1824C22.1011 19.2468 22.1011 16.1073 19.763 14.1708Z",
    fill: "#1C9952"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7638 19.4304V14.1708",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8873 17.1624C19.4287 16.6207 19.7635 15.8736 19.7635 15.0468C19.7638 15.8736 19.4287 16.6207 18.8873 17.1624Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8873 18.9161C19.4287 18.3744 19.7635 17.6261 19.7635 16.8002C19.7638 17.6261 19.4287 18.3746 18.8873 18.9161Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7638 15.924C19.763 16.6903 20.0556 17.4559 20.6393 18.0406C20.0554 17.4557 19.763 16.6903 19.7638 15.924Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5692 10.2555C8.66232 9.38761 6.05112 11.1319 5.73936 14.1514C8.64816 15.0185 11.2584 13.2751 11.5692 10.2555Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6392 10.0656C10.3037 12.4332 8.66136 14.0419 6.55344 14.328C9.12048 14.6777 11.2879 12.9898 11.5692 10.2555C11.2546 10.1616 10.9438 10.0999 10.6392 10.0656Z",
    fill: "#1C9952"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1122 11.2291L5.73936 14.1509",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7132 13.2173C7.96248 13.0682 7.15464 13.2045 6.46776 13.6641",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1717 12.2431C9.42024 12.0943 8.6124 12.2316 7.92528 12.6902",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19688 13.1769C7.83432 12.7519 8.30832 12.0835 8.4696 11.273",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5813 3.03983C15.6734 2.17199 13.0622 3.91607 12.7514 6.93575C15.6593 7.80311 18.2695 6.05927 18.5813 3.03983Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6297 2.8476C17.2442 5.19432 15.5995 6.78936 13.4942 7.10112C16.0913 7.49184 18.2966 5.7996 18.5813 3.03984C18.2594 2.9436 17.9417 2.88144 17.6297 2.8476Z",
    fill: "#1C9952"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1238 4.01331L12.7514 6.93531",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7253 6.00189C14.9738 5.85261 14.167 5.98893 13.4789 6.44877",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1833 5.0275C16.4326 4.8787 15.6238 5.01598 14.9376 5.47486C15.6238 5.01574 16.4326 4.8787 17.1833 5.0275Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2082 5.96135C14.8464 5.53631 15.3204 4.86791 15.4817 4.05743",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42864 17.861C9.23928 19.8754 10.7194 21.3562 12.7349 21.1666C12.9235 19.1518 11.4434 17.6717 9.42864 17.861Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.701 21.168C12.7126 21.167 12.7234 21.1677 12.7349 21.1665C12.9235 19.1515 11.4437 17.6714 9.42864 17.861C9.39912 18.1759 9.41448 18.4754 9.46224 18.7598C11.1458 18.6168 12.4452 19.6428 12.701 21.168Z",
    fill: "#1C9952"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2545 18.6879L12.7342 21.1666",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.737 19.3428C11.737 19.8537 11.9314 20.364 12.3216 20.7542",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9074 20.3407C11.5478 19.9786 11.0484 19.7554 10.4976 19.7554C11.0484 19.7551 11.5478 19.9786 11.9074 20.3407Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41608 10.8492C2.22768 12.8633 3.70752 14.3436 5.72256 14.1547C5.91192 12.1397 4.43184 10.6599 2.41608 10.8492Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6892 14.1559C5.70072 14.155 5.71152 14.1557 5.7228 14.1545C5.91216 12.1394 4.43208 10.6596 2.41632 10.849C2.3868 11.1636 2.4024 11.4634 2.4504 11.7475C4.13424 11.605 5.43384 12.6307 5.6892 14.1559Z",
    fill: "#1C9952"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24312 11.6755L5.7228 14.1547",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7256 12.3307C4.7256 12.8417 4.92 13.3519 5.30928 13.7417",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.896 13.3282C4.53528 12.9665 4.03608 12.7435 3.48528 12.743",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0738 10.4796C16.2629 8.46626 14.783 6.98546 12.7673 7.17482C12.5794 9.18962 14.0594 10.6697 16.0738 10.4796Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.767 7.1748C12.7661 7.18608 12.7666 7.19688 12.7656 7.2084C14.2918 7.46352 15.318 8.76384 15.175 10.4465C15.4591 10.494 15.7589 10.5096 16.0735 10.4798C16.2629 8.46624 14.783 6.9852 12.767 7.1748Z",
    fill: "#1C9952"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2474 9.65352L12.768 7.17432",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.765 8.9983C13.765 8.48782 13.5706 7.9771 13.181 7.58734",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5948 8.00061C13.9553 8.36277 14.4547 8.58525 15.0055 8.58597",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7638 14.1708C19.7638 10.2984 16.6243 7.15826 12.7514 7.15826C8.8788 7.15826 5.73936 10.2984 5.73936 14.1708C5.73936 18.043 8.8788 21.1824 12.7514 21.1824",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90656 18.1586C6.98136 20.0381 9.73272 21.1824 12.7514 21.1824C9.73272 21.1824 6.98112 20.0381 4.90656 18.1586Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7384 14.1703C5.7384 11.1516 6.88344 8.40074 8.76312 6.32642",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7514 7.15826C15.7685 7.15826 18.5184 8.30258 20.593 10.1806",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48248 18.3432C4.80537 18.3432 5.06712 18.0815 5.06712 17.7586C5.06712 17.4357 4.80537 17.174 4.48248 17.174C4.15959 17.174 3.89784 17.4357 3.89784 17.7586C3.89784 18.0815 4.15959 18.3432 4.48248 18.3432Z",
    fill: "#E84B3C",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 10.5821C21.6 10.9044 21.3389 11.1667 21.0154 11.1667C20.6928 11.1667 20.4317 10.9046 20.4317 10.5821C20.4317 10.2595 20.6928 9.99744 21.0154 9.99744C21.3389 9.99744 21.6 10.2595 21.6 10.5821Z",
    fill: "#E84B3C",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0154 9.99744C20.9359 9.99744 20.8601 10.0138 20.7905 10.0426C21.0019 10.1309 21.15 10.339 21.15 10.5818C21.15 10.8247 21.0019 11.0328 20.7905 11.1211C20.8598 11.1502 20.9357 11.1662 21.0154 11.1662C21.3389 11.1662 21.6 10.9042 21.6 10.5816C21.6 10.2595 21.3389 9.99744 21.0154 9.99744Z",
    fill: "#C94033"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74616 5.90137C9.74616 6.22465 9.4848 6.48601 9.16128 6.48601C8.83896 6.48601 8.5776 6.22465 8.5776 5.90137C8.5776 5.57905 8.83896 5.31769 9.16128 5.31769C9.4848 5.31769 9.74616 5.57905 9.74616 5.90137Z",
    fill: "#E84B3C",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16128 5.31769C9.08184 5.31769 9.006 5.33401 8.93664 5.36281C9.14784 5.45113 9.29592 5.65921 9.29592 5.90209C9.29592 6.14497 9.14784 6.35305 8.93664 6.44137C9.00576 6.47041 9.0816 6.48673 9.16128 6.48673C9.4848 6.48673 9.74616 6.22465 9.74616 5.90209C9.74616 5.57977 9.4848 5.31769 9.16128 5.31769Z",
    fill: "#C94033"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48248 17.1741C4.4028 17.1741 4.32696 17.1902 4.2576 17.2193C4.4688 17.3073 4.61712 17.5154 4.61712 17.7585C4.61712 18.0014 4.4688 18.2095 4.2576 18.2978C4.32672 18.3266 4.40256 18.3429 4.48248 18.3429C4.80576 18.3429 5.06712 18.0806 5.06712 17.7583C5.06712 17.436 4.80576 17.1741 4.48248 17.1741Z",
    fill: "#C94033"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7638 21.1824C22.1011 19.247 22.1011 16.1073 19.763 14.1708C17.4262 16.1073 17.4262 19.2458 19.7638 21.1824Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5692 10.2555C8.66232 9.38761 6.05112 11.1319 5.73936 14.1514C8.64816 15.0185 11.2584 13.2751 11.5692 10.2555Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5813 3.03983C15.6734 2.17199 13.0622 3.91607 12.7514 6.93575C15.6593 7.80311 18.2695 6.05927 18.5813 3.03983Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42864 17.861C9.23928 19.8754 10.7194 21.3562 12.7349 21.1666C12.9235 19.1518 11.4434 17.6717 9.42864 17.861Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41608 10.8492C2.22768 12.8633 3.70752 14.3436 5.72256 14.1547C5.91192 12.1397 4.43184 10.6599 2.41608 10.8492Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0738 10.4796C16.2629 8.46626 14.783 6.98546 12.7673 7.17482C12.5794 9.18962 14.0594 10.6697 16.0738 10.4796Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48248 18.3432C4.80537 18.3432 5.06712 18.0815 5.06712 17.7586C5.06712 17.4357 4.80537 17.174 4.48248 17.174C4.15959 17.174 3.89784 17.4357 3.89784 17.7586C3.89784 18.0815 4.15959 18.3432 4.48248 18.3432Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 10.5821C21.6 10.9044 21.3389 11.1667 21.0154 11.1667C20.6928 11.1667 20.4317 10.9046 20.4317 10.5821C20.4317 10.2595 20.6928 9.99744 21.0154 9.99744C21.3389 9.99744 21.6 10.2595 21.6 10.5821Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74616 5.90137C9.74616 6.22465 9.4848 6.48601 9.16128 6.48601C8.83896 6.48601 8.5776 6.22465 8.5776 5.90137C8.5776 5.57905 8.83896 5.31769 9.16128 5.31769C9.4848 5.31769 9.74616 5.57905 9.74616 5.90137Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon2);
export default __webpack_public_path__ + "static/media/PlantIcon2.7f7d3b2ac0bf17fc248d29c87a738186.svg";
export { ForwardRef as ReactComponent };